import { render, staticRenderFns } from "./InfoTeams.vue?vue&type=template&id=7b3da536&scoped=true"
import script from "./InfoTeams.vue?vue&type=script&lang=js"
export * from "./InfoTeams.vue?vue&type=script&lang=js"
import style0 from "./InfoTeams.vue?vue&type=style&index=0&id=7b3da536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3da536",
  null
  
)

export default component.exports